import React, { useState } from "react";
import { Box, Container, TextField } from "@mui/material";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

// export const API_BASE_URL = "http://176.97.70.204:8081";
export const API_BASE_URL = "https://api.lingkniti.com";

const SignUp: React.FC<{
  onSignUpSuccess: () => void;
  handleCancelSignUp: () => void;
}> = ({ onSignUpSuccess, handleCancelSignUp }) => {
  const [accountId, setAccountId] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();

  const handleSignUp = async () => {
    if (!accountId || !password || !name || !phone) {
      window.alert("모든 값은 필수 항목 입니다.");
      return;
    }

    const signUpData = {
      accountId,
      password,
      name,
      phone,
      role: "USER",
    };

    try {
      const response = await fetch(`${API_BASE_URL}/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(signUpData),
      });

      if (!response.ok) {
        throw new Error("회원가입 실패");
      }

      onSignUpSuccess();
    } catch (error) {
      window.alert("회원가입 실패");
    }
  };

  return (
    <>
      <Container maxWidth="xs" style={{ marginTop: "50px" }}>
        <Typography variant="h5" align="center" gutterBottom>
          회원가입
        </Typography>
        <Box component="form" noValidate autoComplete="off">
          <TextField
            label="아이디"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={accountId}
            onChange={(e) => setAccountId(e.target.value)}
          />
          <TextField
            label="비밀번호"
            variant="outlined"
            type="password"
            fullWidth
            margin="normal"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            label="이름"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="연락처"
            variant="outlined"
            fullWidth
            margin="normal"
            required
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSignUp}
            style={{
              marginBottom: "10px",
            }}
          >
            회원가입
          </Button>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            onClick={handleCancelSignUp}
            style={{
              marginBottom: "2rem",
            }}
          >
            닫기
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default SignUp;
